import React from 'react'

export default function CompanyNews() {
  return (
    <div>CompanyNews</div>
  )
}
